import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import NoteForm, { NoteFormRef, NoteValues } from './NoteForm';
import { INote } from '@nxsys/types/models/note';

type EditNoteModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: NoteValues) => Promise<void>;
  data: INote | null;
};

const EditNoteModal: React.FC<EditNoteModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditNoteModalProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<NoteFormRef>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdateNewNote = async (values: NoteValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error('Failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editNote']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <NoteForm
        formRef={formRef}
        onSubmit={handleUpdateNewNote}
        defaultValues={{
          title: data?.title || '',
          content: data?.content || '',
        }}
      />
    </AppModalContainer>
  );
};

export default EditNoteModal;
